import styled from 'styled-components';

export const DashboardContainer = styled.div`
  box-sizing: border-box;

  padding: 20px;
  margin: 0 40px;
  border-radius: 8px;
  min-height: 100vh;
`;

export const DashboardHeader = styled.div`
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 60px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  background: #ffffff;
`;

export const HeaderTitle = styled.div`
  p {
    font-size: 22px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 12px 0;
    line-height: 28px;
  }
`;

export const DashBoardChartsContent = styled.div`
  display: flex;
  flex: 1;
  align-items: stretch;
  justify-content: center;
  margin-bottom: 30px;
`;

export const DashBoardRespondentStatistics = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: stretch;
  justify-content: center;
  margin-bottom: 30px;
  gap: 20px;
`;

export const DashboardFilterContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`;

export const DashboardChartBox = styled.div`
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  margin: 10px;
  padding: 20px;
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: translateY(-2px);
  }

  .styled-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 16px;
    color: #333;

    thead {
      tr {
        th {
          background: #f8f9fa;
          color: #1a1a1a;
          font-weight: 600;
          padding: 12px 16px;
          text-align: left;
          border-bottom: 2px solid #e0e0e0;
          position: sticky;
          top: 0;
          z-index: 10;
        }
      }
    }

    tbody {
      tr {
        background: #ffffff;
        transition: background 0.2s ease;

        &:nth-child(even) {
          background: #f9f9f9;
        }

        &:hover {
          background: #e6f0fa;
        }

        td {
          padding: 12px 16px;
          border-bottom: 1px solid #e0e0e0;
        }
      }
    }
  }
`;

export const DashoboardFilterBox = styled.div`
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  margin: 10px;
  padding: 20px;
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: translateY(-2px);
  }

  p {
    font-size: 16px;
    font-weight: 500;
    color: #1a1a1a;
    margin-bottom: 10px;
  }

  select {
    border: 1px solid #d0d0d0;
    border-radius: 4px;
    padding: 10px;
    font-size: 14px;
    transition: border-color 0.2s ease;

    &:focus {
      border-color: #030303;
      outline: none;
    }
  }
`;

export const ContainerEmpty = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  margin-top: 150px;
  color: #666;
  font-size: 16px;

  .loading-spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #030303;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const SummaryBox = styled.div`
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin: 10px;
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: translateY(-2px);
  }

  h3 {
    font-size: 16px;
    font-weight: 500;
    color: #1a1a1a;
    margin-bottom: 8px;
  }

  p {
    font-size: 24px;
    font-weight: 700;
    color: #030303;
  }
`;

export const HelpIcon = styled.span`
  position: relative;
  cursor: pointer;
  user-select: none;
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  border-radius: 50%;
  background: #eee;
  color: #333;

  .tooltip {
    position: absolute;
    bottom: 125%; /* sobe o balão */
    left: 50%;
    transform: translateX(-5%);
    background: #1a1a1a;
    color: #fff;
    padding: 6px 10px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.15s ease;
    z-index: 9999;
  }

  .tooltip::after {
    content: '';
    position: absolute;
    top: 100%; /* base da seta encosta no balão */
    right: 92%;
    // transform: translateX(-50%);
    border-width: 6px 6px 0 6px;
    border-style: solid;
    border-color: #1a1a1a transparent transparent transparent;
  }

  /* mostra o balão quando o mouse está em cima */
  &:hover .tooltip {
    opacity: 1;
    visibility: visible;
    z-index: 9999;
  }
`;
